export enum EnumSituacao {
  TODAS = 0,
  ATIVO = 1,
  INATIVO = 2,
}
